import QrCode from 'qrcode-svg';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Injectable, inject } from '@angular/core';

import { MaxChars, QrCodeOptions } from './qr-code.model';

const defaultOptions: QrCodeOptions = {
    errorCorrectionLevel: 'M',
    width: 185,
    margin: 0
};

@Injectable()
export class ApQrCodeService {
    private readonly sanitizer = inject(DomSanitizer);

    /**
     * Generate a QR code
     * @param data - string
     * @param qrOptions - QrCodeOptions
     * @returns Promise<SafeHtml>
     */
    public generate(data: string, qrOptions?: QrCodeOptions): Promise<SafeHtml> {
        const options = this.setOptions(qrOptions);
        const maxChars = MaxChars[options.errorCorrectionLevel];
        if (data.length > maxChars) {
            throw new RangeError(`Input too large for QR-code type: ${data.length} > ${maxChars}`);
        }
        return Promise.resolve(
            this.sanitizer.bypassSecurityTrustHtml(
                new QrCode({
                    content: data,
                    padding: options.margin,
                    width: options.width,
                    height: options.width,
                    ecl: options.errorCorrectionLevel
                }).svg()
            )
        );
    }

    /**
     * Sets options to default if they were not set by the user
     *
     * @param options A partial or undefined object with settings
     * @returns options A complete settings object with QrCodeOptions
     */
    private readonly setOptions = (options: QrCodeOptions): QrCodeOptions => ({
        ...defaultOptions,
        ...options
    });
}
